export default {
    install(Vue) {
        Vue.prototype.$can = function (user, permission) {
            if (!user.permissions) {
                return false;
            }

            return user.permissions.indexOf(permission) !== -1;
        };

        Vue.directive("permission", function (el, binding) {

            if (!binding.value.permissions) {
                return el.classList.add('d-none');
            }

            if (binding.value.permissions.indexOf(binding.arg) === -1) {
                return el.classList.add('d-none');
            } else {
                return el.classList.remove('d-none');
            }
        });

        Vue.directive("role", function (el, binding) {
            if (!binding.value.roles) {
                return el.classList.add('d-none');
            }

            let roles = binding.value.roles.map( (role) => {
                return role.name.toLowerCase();
            })

            if (roles.indexOf(binding.arg.toLowerCase()) === -1) {
                return el.classList.add('d-none');
            } else {
                return el.classList.remove('d-none');
            }
        });
    }
}